import { FC, useContext, useEffect, useRef, useState } from "react";
import "./RenewLicense.css";
import WidgetContainer from "../../UiLib/WidgetContainer/WidgetContainer";
import ExitCross from "../../../assets/cancelGreey.svg";
import DateComponent from "../DateComponent/DateComponent";
import { Context } from "../../../index";
import { ILicenseRequestStatus } from "../../../common/api_interfaces/license/ILicenseRequest";
import { ILicenseFunction } from "../../../common/api_interfaces/license/ILicenseFunction";
import Loader from "../../Shared/Loader/Loader";
import ContainerWithOverlay from "../../UiLib/ContainerWithOverlay/ContainerWithOverlay";
import ModalSuccess from "../../Shared/ModalWindows/ModalSuccess";
import ModalError from "../../Shared/ModalWindows/ModalError";
import BtnAdd from "../../buttons/btnAdd.component/BtnAdd";
import TextWithCopy from "../../Shared/TextWithCopy/TextWithCopy";
import SelectDropdown from "../../Shared/SelectDropdown/SelectDropdown";
import Tooltip from "../../UiLib/CustomTooltip/CustomTooltip";
import { ILicenseViewModule, ILicenseViewVersion } from "../../../common/api_interfaces/license/ILicenseView";

enum MessageHeaders {
    success = "Успешно",
    error = "Ошибка",
    warning = "Внимание",
}
interface RenewLicenseErrors {
    moduleCode: string;
    dates?: string;
    license?: string;
    namedCount?: string;
    concurrentCount?: string;
    count?: string;
}
interface IRenewLicense {
    onClose: () => void;
    license?: ILicenseViewVersion;
    allLicenses?: ILicenseViewVersion[];
}

const RenewLicense: FC<IRenewLicense> = ({ onClose, license, allLicenses }) => {
    const { store } = useContext(Context);
    const [errors, setErrors] = useState<RenewLicenseErrors[]>();
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [showSuccess, setShowSuccess] = useState<boolean>(false);
    const [showNotification, setShowNotification] = useState<boolean>(false);
    const [showError, setShowError] = useState<boolean>(false);
    const [showDefaultError, setShowDefaultError] = useState<boolean>(false);

    const [modules, setModules] = useState<ILicenseViewModule[]>([]);
    const [licenseFunctions, setLicenseFunctions] = useState<ILicenseFunction[]>([]);
    const scrollContainerRef = useRef(null);

    const constForIndex = "_3";
    const successMessage = `Запрос на лицензию успешно отправлен! Просьба, если в течение трех дней вы 
                            не получили ответ, отправьте нам на почту ключ`;
    const errorMessage = `Не удалось отправить запрос на лицензию, повторите попытку`;
    const errorNotification = "Не удалось отправить запрос на лицензию. Просим вас отправить нам на почту ключ";
    const defaultError = "Возникла непредвиденная ошибка";

    useEffect(() => {
        (async () => {
            if (license) {
                const licenseCopy = structuredClone(license) as ILicenseViewVersion;
                licenseCopy.modules.forEach((module, i) => {
                    module.dateFrom = undefined;
                    module.dateTo = undefined;
                });
                setModules(licenseCopy.modules);
            } else {
                try {
                    const response: ILicenseFunction[] = (await store.licenseService.getLicenseListForChoise()).data;
                    setLicenseFunctions(response);
                    const lic: ILicenseViewModule = {
                        name: ``,
                        code: ``,
                        count: undefined,
                        dateFrom: new Date().toString(),
                        dateTo: undefined,
                        namedCount: undefined,
                        concurrentCount: undefined,
                    };
                    setModules([lic]);
                } catch (err: any) {
                    setShowDefaultError(true);
                }
            }
        })();
    }, []);

    const handleApproveRequest = async () => {
        setShowLoader(true);
        // Проверка всех дат, что дата окончания не будет меньше даты начала

        const errorMessages: RenewLicenseErrors[] = [];
        modules.forEach((module, i) => {
            const errors: RenewLicenseErrors = {
                moduleCode: module.code,
            };
            errorMessages.push(errors);
            const moduleInfo = licenseFunctions.find((lF) => lF.code === module.code);
            const _dateFrom = module!.dateFrom! ? new Date(module!.dateFrom!) : undefined;
            const _dateTo = module!.dateTo! ? new Date(module!.dateTo!) : undefined;

            if (!_dateFrom || !_dateTo) errors.dates = "Заполните дату";
            else if (_dateFrom >= _dateTo) errors.dates = "";

            if (!license) {
                if (module.name === "") {
                    errors.license = "Выберите лицензию";
                }
                if (moduleInfo?.requiredNamedOrConcurrentCount && !module.concurrentCount && !module.namedCount) {
                    errors.concurrentCount = "Введите число конкурентных или именных пользователей";
                } else {
                    if (moduleInfo?.requiredNamedCount && !module.namedCount)
                        errors.namedCount = "Введите число именных пользователей";
                    if (moduleInfo?.requiredConcurrentCount && !module.concurrentCount)
                        errors.concurrentCount = "Введите число конкурентных пользователей";
                }
                if (moduleInfo?.requiredCount && !module.count) {
                    errors.count = "Введите количество";
                }
            }
        });

        setErrors(errorMessages);

        if (
            errorMessages.some((error) =>
                Object.entries(error).some((e) => e[0] !== "moduleCode" && e[1] !== undefined)
            )
        ) {
            setShowLoader(false);
            return;
        }

        //Продлеваем лицензию
        let request: ILicenseRequestStatus = {
            doesRenewLicense: true,
            licences: modules,
        };
        // Запрашиваем лицензию
        if (!license) {
            request.doesRenewLicense = false;
        }
        try {
            await store.licenseService.requestLicense(request);
            setShowSuccess(true);
            setShowError(false);
            setShowLoader(false);
        } catch (err: any) {
            if (err.response?.status === 500) {
                setShowSuccess(false);
                setShowError(true);
            } else if (err.response?.status === 550) {
                setShowSuccess(false);
                setShowError(false);
                setShowNotification(true);
            }
            setShowLoader(false);
        }
    };

    const handleDropDown = (module: ILicenseViewModule, code: string) => {
        const licenseFunc = licenseFunctions.find((xx) => xx.code === code);
        if (licenseFunc) {
            module.code = licenseFunc.code;
            module.name = licenseFunc.name;
            module.count = licenseFunc.needCount ? 0 : undefined;
            module.concurrentCount = licenseFunc.needConcurrentCount ? 0 : undefined;
            module.namedCount = licenseFunc.needNamedCount ? 0 : undefined;
            setModules([...modules]);
        }
    };

    const handleOpenDropdown = () => {
        requestAnimationFrame(() => {
            if (!scrollContainerRef.current) return;
            const objDiv = scrollContainerRef.current as HTMLDivElement;
            objDiv.scrollTop = objDiv.scrollHeight;
        });
    };

    const handleAddLicense = () => {
        const lic: ILicenseViewModule = {
            name: ``,
            code: ``,
            count: undefined,
            dateFrom: new Date().toString(),
            dateTo: undefined,
            namedCount: undefined,
            concurrentCount: undefined,
        };

        setModules([...modules, lic]);
    };
    const handleCloseModule = (index: number) => {
        const countDeleteItems = 1;
        modules.splice(index, countDeleteItems);

        setModules([...modules]);
    };

    const handleNameCountChange = (count: number, module: ILicenseViewModule) => {
        if (count < 0) return;
        module.namedCount = count;
        setModules([...modules]);
    };

    const handleCountChange = (count: number, module: ILicenseViewModule) => {
        if (count < 0) return;
        module.count = count;
        setModules([...modules]);
    };

    const handleConcurrentChange = (count: number, module: ILicenseViewModule) => {
        if (count < 0) return;
        module.concurrentCount = count;
        setModules([...modules]);
    };

    const createOptions = (module: ILicenseViewModule) => {
        const filterOptions = licenseFunctions
            .filter((opt) => !modules.some((m) => m.code === opt.code))
            .map((opt) => {
                return { name: opt.name, code: opt.code };
            });
        filterOptions.push(module);
        return filterOptions.map((item: any) => {
            return {
                name: item.name,
                code: item.code,
            };
        });
    };

    function getPlatformInfo() {
        let platformInfo: string = "";
        let version: string = "";
        if (license) {
            platformInfo = `${license.deployment} v.${license.version}`;
        } else if (allLicenses) {
            version = allLicenses[0].version;
            platformInfo = allLicenses[0].deployment;
        } else {
            platformInfo = `Не найдена`;
        }
        return (
            <div className="platform-info">
                <div className="text-left">{"Платформа"}</div>
                <TextWithCopy text={platformInfo} />
            </div>
        );
    }

    const getLicenseDropdown = (
        module: ILicenseViewModule,
        selected: { name: string; code: string },
        options: { name: string; code: string }[]
    ) => {
        const selectedOpt = options.find((o) => o.code === selected.code)?.name;
        return (
            <SelectDropdown onOpen={handleOpenDropdown}>
                <SelectDropdown.Selected>
                    <Tooltip text={selectedOpt ?? ""} placement="bottom">
                        <div className="license-option-selected">
                            {selectedOpt !== "" ? selectedOpt : "Выбрать лицензию"}
                        </div>
                    </Tooltip>
                </SelectDropdown.Selected>
                {options.map((opt) => (
                    <SelectDropdown.Option>
                        <div className="license-option" onClick={() => handleDropDown(module, opt.code)}>
                            {opt.name}
                        </div>
                    </SelectDropdown.Option>
                ))}
            </SelectDropdown>
        );
    };

    const getRenewLicense = () => {
        return (
            <div className="modules-container">
                {modules.map((module, index) => {
                    const errorMessage = errors?.find((e) => e.moduleCode === module.code);
                    return (
                        <div id={`${index}${constForIndex}`} className="general-info-main">
                            <div className="general-info">
                                <div className="text-left">{"Лицензия"}</div>
                                <div className="license-name">{module.name}</div>
                            </div>
                            <div className="data-frame-main">
                                <div className="text-left">{"Дата"}</div>
                                <DateComponent errorMessage={errorMessage?.dates} module={module} />
                            </div>
                            {module.namedCount ? (
                                <div className="general-info">
                                    <div className="text-left">{"Количество именных лицензий"}</div>
                                    <div className="license-name">{`${module.namedCount} шт.`}</div>
                                </div>
                            ) : null}
                            {module.concurrentCount ? (
                                <div className="general-info">
                                    <div className="text-left">{"Количество конкурентных лицензий"}</div>
                                    <div className="license-name">{`${module.concurrentCount} шт.`}</div>
                                </div>
                            ) : null}
                            {module.count ? (
                                <div className="general-info">
                                    <div className="text-left">{"Количество"}</div>
                                    <div className="license-name">{`${module.count} шт.`}</div>
                                </div>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        );
    };

    const getRequestLicense = () => {
        return (
            <div className="modules-container">
                {modules.map((module, index) => {
                    const errorMessage = errors?.find((e) => e.moduleCode === module.code);
                    const moduleInfo = licenseFunctions.find((lF) => lF.code === module.code);
                    const needCount = moduleInfo?.needCount;
                    const needConcurrentCount = moduleInfo?.needConcurrentCount;
                    const needNamedCount = moduleInfo?.needNamedCount;
                    const needDates = module.name !== "";

                    return (
                        <div id={`${index}${constForIndex}`} className="general-info-main">
                            {modules.length >= 2 ? (
                                <div className="close-module" title="Закрыть модуль">
                                    <button className="close-button" onClick={() => handleCloseModule(index)}>
                                        <img src={ExitCross} />
                                    </button>
                                </div>
                            ) : null}
                            <div className="general-info">
                                <div className="text-left">{"Лицензия"}</div>
                                <div>
                                    {getLicenseDropdown(module, module, createOptions(module))}
                                    {errorMessage?.license ? (
                                        <div className="error-text">{errorMessage?.license}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div></div>
                            {needDates ? (
                                <div className="data-frame-main">
                                    <div className="text-left">{"Дата"}</div>
                                    <DateComponent
                                        errorMessage={errorMessage?.dates}
                                        module={module}
                                        startDateDefault={new Date()}
                                    />
                                </div>
                            ) : null}
                            {needCount ? (
                                <div className="general-info">
                                    <div className="text-left">{"Количество"}</div>
                                    <input
                                        className="input-count"
                                        type="number"
                                        onChange={(e) => handleCountChange(+e.target.value, module)}
                                        value={module.count?.toString()}
                                    />
                                </div>
                            ) : null}
                            {errorMessage?.count ? <div className="error-text">{errorMessage?.count}</div> : null}
                            {needNamedCount ? (
                                <div className="general-info">
                                    <div className="text-left">{"Количество именных лицензий"}</div>
                                    <input
                                        className="input-count"
                                        type="number"
                                        onChange={(e) => handleNameCountChange(+e.target.value, module)}
                                        value={module.namedCount?.toString()}
                                    />
                                </div>
                            ) : null}
                            {errorMessage?.namedCount ? (
                                <div className="error-text">{errorMessage?.namedCount}</div>
                            ) : null}
                            {needConcurrentCount ? (
                                <div className="general-info">
                                    <div className="text-left">{"Количество конкурентных лицензий"}</div>
                                    <input
                                        className="input-count"
                                        type="number"
                                        onChange={(e) => {
                                            handleConcurrentChange(+e.target.value, module);
                                        }}
                                        value={module.concurrentCount?.toString()}
                                    />
                                </div>
                            ) : null}
                            {errorMessage?.concurrentCount ? (
                                <div className="error-text">{errorMessage?.concurrentCount}</div>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        );
    };

    const containerWithOverlay = (_onClose: any, bodyText: string, headerText: MessageHeaders) => {
        return (
            <ContainerWithOverlay onOverlayClick={() => {}}>
                <div>
                    {headerText === MessageHeaders.success ? (
                        <ModalSuccess onClose={_onClose} bodyText={bodyText} headerText={headerText} />
                    ) : (
                        <ModalError onClose={_onClose} bodyText={bodyText} headerText={headerText} />
                    )}
                </div>
            </ContainerWithOverlay>
        );
    };

    return (
        <WidgetContainer style={{ height: "100%" }}>
            {showLoader ? <Loader /> : null}
            {showSuccess ? containerWithOverlay(onClose, successMessage, MessageHeaders.success) : null}
            {showError || showDefaultError
                ? containerWithOverlay(onClose, showError ? errorMessage : defaultError, MessageHeaders.error)
                : null}
            {showNotification
                ? containerWithOverlay(
                      onClose,
                      showNotification ? errorNotification : defaultError,
                      MessageHeaders.warning
                  )
                : null}
            <div className="widget-start">
                <div className="main-header">
                    <div className="header-continue">{license ? "Продлить лицензию" : "Запросить лицензию"}</div>
                    <button className="close-button" onClick={onClose}>
                        <img src={ExitCross} />
                    </button>
                </div>
                {license ? (
                    <div ref={scrollContainerRef} className="all-info">
                        {getPlatformInfo()}
                        {getRenewLicense()}
                    </div>
                ) : (
                    <div ref={scrollContainerRef} className="all-info">
                        {getPlatformInfo()}
                        {getRequestLicense()}
                        {modules.length !== licenseFunctions.length && !modules.some((m) => m.name === "") ? (
                            <div className="general-info" style={{ justifyContent: "start", gap: "5px" }}>
                                <div className="text-left">{"Добавить лицензию"}</div>
                                <BtnAdd type={"license"} onClickFunc={handleAddLicense} permission={true} />
                            </div>
                        ) : null}
                    </div>
                )}
                <div className="button-main">
                    <button
                        data-testId="button-request_license-request"
                        className="button-right-"
                        onClick={handleApproveRequest}
                    >
                        {"Запросить"}
                    </button>
                    <button data-testId="button-request_license-cancel" className="button-left-" onClick={onClose}>
                        {"Отмена"}
                    </button>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default RenewLicense;
